import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DomainUrlService} from '../config/domain-url.service';
import {Observable} from 'rxjs';

@Injectable({
              providedIn: 'root'
            })
export class AuthenticationService {

  constructor(private httpClient: HttpClient,
              private domainUrlService: DomainUrlService) {
  }

  login(): Observable<boolean> {
    return this.httpClient.get<boolean>(this.domainUrlService.getRepositoryApiUrl() + '/rest/internal/v3/login/loginUser');
  }

  logout(): any {
    localStorage.clear();
    window.location.href = this.domainUrlService.getLoginUrl() + '/logout';
  }

  verifyAuthenticatedDashboardAccess(): Observable<boolean> {
    return this.httpClient.get<boolean>(this.domainUrlService.getOptimPortalBackApiUrl() + '/rest/public/v1/verify/dashboard-access');
  }

}
